import { OnInit, OnDestroy, EventEmitter, QueryList, ElementRef } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';
var CsAgGridGroupRendererComponent = /** @class */ (function () {
    function CsAgGridGroupRendererComponent() {
        this.groups = [];
        this.isDragOver = false;
        this.groupsChanged = new EventEmitter();
        this.groupsAdded = new EventEmitter();
        this.dragCounter = 0;
        this.placeholderIndex = null;
        this.allowFromGlobal = false;
        this.removePlaceHolderIndex = false;
        this.placeholderCount = 0;
        this.resizeDebounceTimer = null;
        this.lastDragOverIndex = null;
        this.dragOverThrottleTimer = null;
        this.pendingDragEvent = null;
    }
    CsAgGridGroupRendererComponent.prototype.ngOnInit = function () {
        this.gridColumnApi = this.gridInstance.gridApi;
    };
    CsAgGridGroupRendererComponent.prototype.onWindowResize = function () {
        var _this = this;
        if (this.groups.length === 0)
            return;
        if (this.resizeDebounceTimer)
            clearTimeout(this.resizeDebounceTimer);
        this.resizeDebounceTimer = setTimeout(function () {
            _this.resizeDebounceTimer = null;
            var wrapperEl = _this.groupFlexWrapperEl && _this.groupFlexWrapperEl.first && _this.groupFlexWrapperEl.first.nativeElement;
            if (wrapperEl) {
                var width = wrapperEl.getBoundingClientRect().width;
                _this.groupElementMaxWidth = width;
                _this.calculateOccupiedWidth(width, '');
            }
        }, 150);
    };
    CsAgGridGroupRendererComponent.prototype.ngOnDestroy = function () {
        if (this.resizeDebounceTimer) {
            clearTimeout(this.resizeDebounceTimer);
            this.resizeDebounceTimer = null;
        }
        this.clearDragOverThrottle();
    };
    CsAgGridGroupRendererComponent.prototype.onDragEnter = function () {
        this.dragCounter++;
        this.isDragOver = true;
        if (this.groups.length && !this.dropdownGroups.length) {
            var draggedEl = document.getElementById('gridDraggedElement');
            var placeholder = draggedEl ? draggedEl.innerText : '';
            var wrapperElement = this.groupFlexWrapperEl.first.nativeElement; // Access the first element in the QueryList
            if (wrapperElement) {
                this.groupElementMaxWidth = this.groupElementMaxWidth ? this.groupElementMaxWidth : wrapperElement.getBoundingClientRect().width;
                this.calculateOccupiedWidth(this.groupElementMaxWidth, placeholder);
            }
            this.allowFromGlobal = true;
        }
    };
    CsAgGridGroupRendererComponent.prototype.onDragLeave = function () {
        this.dragCounter--;
        this.isDragOver = false;
        if (this.dragCounter === 0) {
            this.lastDragOverIndex = null;
            this.clearDragOverThrottle();
        }
    };
    // This method now correctly handles drag over the dropdown button.
    CsAgGridGroupRendererComponent.prototype.onDragOver = function (event) {
        var _this = this;
        this.isDragOver = true;
        event.preventDefault();
        if (!this.groups.length) {
            if (this.placeholderIndex !== 0) {
                this.placeholderIndex = 0;
            }
            return;
        }
        this.pendingDragEvent = event;
        if (this.dragOverThrottleTimer === null) {
            this.applyDragOverPosition(event);
            this.dragOverThrottleTimer = setTimeout(function () {
                _this.dragOverThrottleTimer = null;
                var e = _this.pendingDragEvent;
                _this.pendingDragEvent = null;
                if (e && _this.groups.length) {
                    _this.applyDragOverPosition(e);
                }
            }, 32);
        }
    };
    CsAgGridGroupRendererComponent.prototype.applyDragOverPosition = function (event) {
        var groupEls = this.groupLabelEls.toArray();
        var index = this.groups.length;
        var found = false;
        if (groupEls.length === 0) {
            index = this.sliceIndex ? this.visibleGroups.length : this.groups.length;
        }
        else {
            groupEls.forEach(function (elRef, i) {
                if (found)
                    return;
                var rect = elRef.nativeElement.getBoundingClientRect();
                if (event.clientX < rect.left + rect.width / 2) {
                    index = i;
                    found = true;
                }
            });
        }
        if (this.lastDragOverIndex === index) {
            return;
        }
        this.lastDragOverIndex = index;
        this.placeholderIndex = index;
        // When over the right (past all visible pills): show placeholder at end of visible row only.
        // Do NOT change sliceIndex/placeholderCount during drag - that resizes the drop target and
        // causes dragleave/dragenter flicker ("applied, remove, applied, remove").
        if (this.placeholderIndex === this.groups.length && this.sliceIndex) {
            this.placeholderIndex = this.visibleGroups.length;
        }
    };
    CsAgGridGroupRendererComponent.prototype.onDrop = function (event) {
        event.preventDefault();
        this.isDragOver = false;
        if (this.dragOverThrottleTimer !== null) {
            clearTimeout(this.dragOverThrottleTimer);
            this.dragOverThrottleTimer = null;
            this.pendingDragEvent = null;
            if (this.groups.length) {
                this.lastDragOverIndex = null;
                this.applyDragOverPosition(event);
            }
        }
        this.lastDragOverIndex = null;
        var raw = event.dataTransfer.getData('application/vnd.aggrid.coldef+json');
        if (!raw)
            return;
        var addedGroup = false;
        try {
            var colDef_1 = JSON.parse(raw);
            if (!colDef_1.field)
                return;
            var isAlreadyGrouped = this.groups.some(function (g) { return g.field === colDef_1.field; });
            if (isAlreadyGrouped)
                return;
            var insertIndex = this.placeholderIndex !== -1 ? this.placeholderIndex : this.groups.length;
            this.groups.splice(insertIndex, 0, colDef_1); // insert at placeholderIndex
            addedGroup = true;
            // Emit event when groups are added (length > 0)
            if (this.groups.length > 0) {
                this.groupsAdded.emit(this.groups.length);
            }
            this.groupsChanged.emit(this.groups);
            this.gridColumnApi.setRowGroupColumns(this.groups.map(function (col) { return col.field; }));
            this.gridInstance.refreshGridData();
        }
        catch (err) {
            console.error('Drop parsing failed', err);
        }
        this.placeholderIndex = null;
        if (this.removePlaceHolderIndex) {
            this.sliceIndex++;
            this.removePlaceHolderIndex = false;
        }
        this.allowFromGlobal = false;
        if (this.placeholderCount) {
            this.sliceIndex += this.placeholderCount;
            this.placeholderCount = 0;
        }
        if (addedGroup) {
            this.recalculateOccupiedWidthAfterViewUpdate();
        }
    };
    CsAgGridGroupRendererComponent.prototype.removeGroup = function (index) {
        this.groups.splice(index, 1);
        this.groupsChanged.emit(this.groups); // emit after remove
        // Emit event when groups are removed (count becomes 0 or still > 0)
        this.groupsAdded.emit(this.groups.length);
        // Update ag-Grid with the new list of field names
        var groupFields = this.groups.map(function (col) { return col.field; });
        this.gridColumnApi.setRowGroupColumns(groupFields);
        this.gridInstance.refreshGridData();
        this.gridInstance.refreshHeaders();
        this.recalculateOccupiedWidthAfterViewUpdate();
    };
    CsAgGridGroupRendererComponent.prototype.onPillDrop = function (event) {
        if (event.previousIndex === event.currentIndex)
            return;
        moveItemInArray(this.groups, event.previousIndex, event.currentIndex);
        this.groupsChanged.emit(this.groups);
        this.gridColumnApi.setRowGroupColumns(this.groups.map(function (col) { return col.field; }));
        this.gridInstance.refreshGridData();
        this.gridInstance.refreshHeaders();
        this.recalculateOccupiedWidthAfterViewUpdate();
    };
    CsAgGridGroupRendererComponent.prototype.clearDragOverThrottle = function () {
        if (this.dragOverThrottleTimer !== null) {
            clearTimeout(this.dragOverThrottleTimer);
            this.dragOverThrottleTimer = null;
        }
        this.pendingDragEvent = null;
        this.lastDragOverIndex = null;
    };
    CsAgGridGroupRendererComponent.prototype.onGlobalDragEnd = function (event) {
        var _this = this;
        this.clearDragOverThrottle();
        if (this.groups.length && this.allowFromGlobal) {
            var wrapperElement = this.groupFlexWrapperEl.first.nativeElement; // Access the first element in the QueryList
            if (wrapperElement) {
                var width = wrapperElement.getBoundingClientRect().width;
                this.calculateOccupiedWidth(width, '');
            }
            this.allowFromGlobal = false;
        }
        this.dragCounter = 0;
        this.isDragOver = false;
        this.placeholderIndex = null;
        if (this.placeholderCount) {
            this.sliceIndex += this.placeholderCount;
            this.placeholderCount = 0;
        }
        // Recalc again after a short delay so header/grid have finished updating and "+N" count shows
        if (this.groups.length > 0) {
            setTimeout(function () { return _this.recalculateOccupiedWidthAfterViewUpdate(); }, 80);
        }
    };
    Object.defineProperty(CsAgGridGroupRendererComponent.prototype, "visibleGroups", {
        get: function () {
            return this.groups.slice(0, this.sliceIndex ? this.sliceIndex : this.groups.length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsAgGridGroupRendererComponent.prototype, "dropdownGroups", {
        get: function () {
            return this.sliceIndex ? this.groups.slice(this.sliceIndex) : [];
        },
        enumerable: true,
        configurable: true
    });
    /** Recalculate visible/dropdown split after the view has updated (e.g. after add/reorder/remove). */
    CsAgGridGroupRendererComponent.prototype.recalculateOccupiedWidthAfterViewUpdate = function () {
        var _this = this;
        if (this.groups.length === 0)
            return;
        // Run after two ticks so Angular and the grid have rendered the new/removed pills
        setTimeout(function () {
            setTimeout(function () {
                var wrapperEl = _this.groupFlexWrapperEl && _this.groupFlexWrapperEl.first && _this.groupFlexWrapperEl.first.nativeElement;
                if (wrapperEl) {
                    var width = wrapperEl.getBoundingClientRect().width;
                    _this.groupElementMaxWidth = width;
                    _this.calculateOccupiedWidth(width, '');
                }
            }, 0);
        }, 0);
    };
    // Add this method to handle dropdown group removal:
    CsAgGridGroupRendererComponent.prototype.removeDropdownGroup = function (dropdownIndex) {
        var actualIndex = this.sliceIndex + dropdownIndex;
        this.removeGroup(actualIndex);
    };
    CsAgGridGroupRendererComponent.prototype.calculateOccupiedWidth = function (overAllWidth, placeholder) {
        var totalWidth = 0;
        var updatedIndex = undefined;
        var groupFlexWrapperGap = 8; // From your CSS: gap: 12px;;
        var placeholderWidth = placeholder ? Math.max(this.calculateWidthOfGroupElements(placeholder), 100) : 100; // From your CSS: width: 100px;
        var dropdownWidth = 0;
        if (this.dropdownGroups.length > 0 && this.dropDownElementRef && this.dropDownElementRef.nativeElement) {
            dropdownWidth = this.dropDownElementRef.nativeElement.getBoundingClientRect().width;
        }
        else if (this.dropDownElementRef && this.dropDownElementRef.nativeElement) {
            dropdownWidth = 50; // reserve space for "+N" when dropdown will appear
        }
        var availableWidth = overAllWidth - dropdownWidth - groupFlexWrapperGap;
        var WIDTH_TOLERANCE_PX = 2;
        var groupLabelElements = this.groupLabelEls.toArray();
        var insertIndex = this.placeholderIndex != null ? this.placeholderIndex : this.groups.length;
        groupLabelElements.splice(insertIndex, 0, { width: placeholderWidth, isPlaceHolder: true });
        groupLabelElements.forEach(function (elRef, index) {
            var labelWidth = elRef.hasOwnProperty('isPlaceHolder') ? elRef.width : elRef.nativeElement.getBoundingClientRect().width;
            totalWidth += labelWidth;
            if (index < groupLabelElements.length - 1) {
                totalWidth += groupFlexWrapperGap;
            }
            if ((availableWidth + WIDTH_TOLERANCE_PX) < totalWidth && updatedIndex === undefined) {
                updatedIndex = index;
            }
        });
        this.removePlaceHolderIndex = !!(this.placeHolderEL && updatedIndex);
        this.sliceIndex = updatedIndex;
    };
    CsAgGridGroupRendererComponent.prototype.calculateWidthOfGroupElements = function (content) {
        if (content === void 0) { content = ''; }
        var dragPreviewEl = document.createElement('div');
        dragPreviewEl.innerText = content;
        Object.assign(dragPreviewEl.style, {
            padding: '4px 8px',
            background: '#e1fcda',
            border: '1px solid #c3e6cb',
            borderRadius: '2px',
            fontSize: '13px',
            fontFamily: 'inherit',
            color: '#2e7d32',
            position: 'absolute',
            top: '-1000px'
        });
        document.body.appendChild(dragPreviewEl);
        var width = dragPreviewEl.offsetWidth + 17;
        document.body.removeChild(dragPreviewEl);
        return width;
    };
    return CsAgGridGroupRendererComponent;
}());
export { CsAgGridGroupRendererComponent };
